import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function useLiveGrades() {
  const [grades, setGrades] = useState([1, 2, 3, 4, 5, 6]);
  useEffect(() => { api.get("/grades/live").then(({ data }) => setGrades(data.grades)).catch(() => {}); }, []);
  return grades;
}
